import { Component } from '@angular/core';
import moment from 'moment';
import { XpoFilterCondition } from '../../../condition';
import { XpoConditionTimeAfterComponent } from '../../time/after/after.component';
import { ordersMinMaxTime } from '../../time/time.util';
import { Operators, OperatorText } from './../../../../../models/index';

@Component({
  templateUrl: './after.component.html',
  styleUrls: ['../../validator.scss'],
})
export class XpoConditionTimeRangeAfterComponent extends XpoConditionTimeAfterComponent implements XpoFilterCondition {
  static text: string = OperatorText.After;
  static operator: Operators = Operators.After;

  constructor() {
    super();
  }

  validate(cellValue): boolean {
    // Do not validate if input is empty
    if (!this.model) {
      return true;
    }

    if (!cellValue || !cellValue.from || !cellValue.to) {
      return false;
    }

    const cellValueFrom = moment(cellValue.from, 'h:mma');
    const cellValueTo = moment(cellValue.to, 'h:mma');
    const model = moment(this.model, 'h:mma');

    return cellValueFrom.isAfter(model) || cellValueTo.isAfter(model);
  }
}
